export { default } from './SWSectionStandardBanner';